import { render, staticRenderFns } from "./HeaderSubMenu.vue?vue&type=template&id=3e8b97c4&scoped=true"
import script from "./HeaderSubMenu.vue?vue&type=script&lang=js"
export * from "./HeaderSubMenu.vue?vue&type=script&lang=js"
import style0 from "./HeaderSubMenu.vue?vue&type=style&index=0&id=3e8b97c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8b97c4",
  null
  
)

export default component.exports